import axios from "axios";
import { urlCoreBack } from "../configs/config";
import '../utils/axios.interceptor';

const epName = "v1/cr-lista-precio/";
const epNameListaReferencia = "v1/cr-lista-precio-reference/";
const nameItemsText = "Listas de Precios de Cristales";
const nameItemText = "Lista de Precio de Cristal";
const itemGender = "F";

//
// #############################################################################
//
export const getCrListasPrecios = async (params) => {
	let _params = {};
	let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;
	if (params) {
		if (params.idProveedor) {
			_params.id_proveedor = params.idProveedor;
		}
		if (params.idProducto) {
			_params.id_cristal_producto = params.idProducto;
		}
		if (params.idBlCrDiametro) {
			_params.id_bl_cr_diametro = params.idBlCrDiametro;
		}
		if (params.habilitado) {
			_params.habilitado = params.habilitado === "habilitado" ? "H" : params.habilitado === "deshabilitado" ? "D" : "";
		}
		if (params.referencia) {
			_params.referencia = params.referencia === "solo-referencia" ? "S" : params.referencia === "solo-no-referencia" ? "N" : "T";
		}
		if (params.rows) {
			_params.rows = params.rows;
		}
		if (params.first) {
			_params.first = params.first;
		}
		if (params.idCrLprecioRango) {
			_params.id_cr_lprecio_rango = params.idCrLprecioRango;
		}

	}
	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};

//
// #############################################################################
//
export const getCrListaPrecio = async (params) => {
	let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;
	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};

//
// #############################################################################
//
export const saveCrListaPrecio = async (actionCrud, item) => {
	let _errorMessage = `Se produjo un error al guardar ${nameItemsText}`;
	let _actionCrud = ""
	let _objListaReferencia = {}
	let _item = {
		id_proveedor: item.idProveedor,
		id_cristal_producto: item.idCristalProducto,
		id_bl_cr_diametro: item.idBlCrDiametro,
		adiciones_list: item.adicionesList,
		rangos_list: item.rangosList,
		observaciones: item.observaciones,
	};
	if (actionCrud !== "new") {
		_item.id = item.id;
	}
	if (actionCrud === "disable") {
		_actionCrud = "D";
	} else if (actionCrud === "enable") {
		_actionCrud = "H";
	}

	if (actionCrud === "mark-as-reference") {
		_objListaReferencia = {
			id: item.id,
		};
	}

	try {
		let response = {};
		if (actionCrud === "new") {
			response = await axios({
				method: "POST",
				url: `${urlCoreBack}${epName}`,
				data: _item,
			});
		} else if (actionCrud === "update") {
			response = await axios({
				method: "PUT",
				url: `${urlCoreBack}${epName}`,
				data: _item,
			});
		} else if (actionCrud === "disable" || actionCrud === "enable") {
			response = await axios({
				method: "DELETE",
				url: `${urlCoreBack}${epName}`,
				params: {
					id: _item.id,
					action: _actionCrud,
				},
			});
		} else if (actionCrud === "mark-as-reference") {
			response = await axios({
				method: "PUT",
				url: `${urlCoreBack}${epNameListaReferencia}`,
				data: _objListaReferencia,
			});
		}
		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				response.messageText =
					`${nameItemText}` +
					(actionCrud === "disable" ? itemGender === "M" ? " deshabilitado" : " deshabilitada" : actionCrud === "enable" ? itemGender === "M" ? " habilitado" : " habilitada" : itemGender === "M" ? " guardado" : " guardada");
				response.messageSeverity = "success";
			} else {
				// si hay error controlado
				console.log(_errorMessage);
				console.log(response);
				let _message_code = response.data.code;
				if (_message_code === "err-cr-lprecio-already-exist") {
					response.messageText = "Ya existe una Lista de Precios con la misma descripción";
				}
				else if (_message_code === "err-cr-lprecio-marcar-lp-cr-as-reference") {
					response.messageText = "La Lista de Precios es la de referencia. Primero seleccione otra Lista de Precios de referencia";
				}
				else {
					response.messageText = _errorMessage;
				}
				response.ok = false;
				response.messageSeverity = "error";
				return response;
			}
		}
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
